export const iataAgenciesTranslations = {
  ua: {
    metaTitle: 'Рішення для IATA-турагентств | Доступ до авіаконтенту через DRCT',
    metaDescription:
      'Отримуйте авіаконтент NDC і GDS на одній платформі. DRCT допомагає IATA-агентствам спростити бронювання, не перемикатися між системами та ефективно керувати квитками й післяпродажним обслуговуванням.',
    heroContent: {
      title: 'Для IATA-агентств',
      subtitle:
        'Прямий доступ до пропозицій авіакомпаній для IATA-агентств, які обслуговують приватних і корпоративних клієнтів. NDC інтегрується у звичні робочі процеси, усі операції виконуються за єдиною логікою, а команда підтримки доступна цілодобово.',
      description:
        'Агентства з акредитацією IATA мають справу зі складними процесами, які більшість платформ не враховує: зобов’язаннями щодо GDS, звітністю BSP, неузгодженістю NDC та звіркою даних із бек-офісом. DRCT об’єднує все це в одній системі, щоб ваша команда могла зосередитися на продажах, а не на постійному вирішенні операційних проблем.',
      ctaLabel: 'Запланувати демо',
    },
    distributionContent: {
      heading: 'Як DRCT вирішує проблеми агентської дистрибуції',
      description:
        'DRCT усуває прогалини в контенті, спрощує робочі процеси й централізує розрахунки BSP — усе на одній платформі.',
      tabOneLabel: 'Дистрибуція та зростання',
      tabTwoLabel: 'Операції та контроль',
      tabOneCards: [
        {
          title: 'Прямий доступ до повного контенту авіакомпаній',
          description:
            'DRCT надає прямий доступ до повного контенту авіакомпаній — зокрема тарифів NDC, бандлів і додаткових послуг — у єдиному зведеному вигляді.',
        },
        {
          title: 'Контрольоване зростання NDC',
          description:
            'DRCT дає змогу поступово збільшувати частку NDC, зберігаючи збалансовану структуру каналів дистрибуції та повний доступ до пропозицій авіакомпаній.',
        },
      ],
      tabTwoCards: [
        {
          title: 'Пропозиції авіакомпаній у поточних процесах',
          description:
            'DRCT інтегрує пропозиції авіакомпаній у ваші робочі процеси: пошук, бронювання й обслуговування відбуваються в одному місці з узгодженими даними.',
        },
        {
          title: 'Централізоване керування замовленнями NDC',
          description:
            'DRCT централізує керування замовленнями NDC в одному інтерфейсі та надає цілодобову підтримку у складних випадках.',
        },
        {
          title: 'Єдина звітність і звірка',
          description:
            'DRCT об’єднує звітність і облік NDC в одному процесі — від бронювання до остаточної звірки.',
        },
      ],
    },
    workflowContent: {
      heading: 'Як це працює',
      description:
        'Від доступу до контенту й бронювання до обліку та післяпродажної підтримки — усі етапи об’єднує єдиний шар DRCT.',
      sourceEyebrow: 'Пропозиція',
      sourceHeading: 'Контент авіакомпаній',
      sourceItems: ['NDC', 'Лоукост-перевізники', 'Чартери'],
      coreHeading: 'Збагачення та доставка',
      pipelineSteps: [
        { number: '01', text: 'Збагачення — додаткові послуги, пакети, ціни' },
        { number: '02', text: 'Доставка — в інтерфейс агента' },
        { number: '03', text: 'Продаж — бронювання, виписка, звітність' },
      ],
      coreEyebrow: 'Єдиний шар',
      coreNote: 'Післяпродажне обслуговування: зміни, повернення та інша робота з бронюваннями',
      destEyebrow: 'Продаж і післяпродажне обслуговування',
      destHeading: 'Інтерфейс агента',
      destItems: ['Доставка', 'Продаж', 'Післяпродажне обслуговування'],
      steps: [
        {
          heading: 'Збагачення пропозицій',
          description:
            'Контент авіакомпаній із різних джерел нормалізується і збагачується: додаткові послуги, вибір місць і динамічні пакети об’єднуються в повні пропозиції, які легко порівнювати.',
        },
        {
          heading: 'Інтеграція у звичні робочі процеси',
          description:
            'Збагачені пропозиції надходять безпосередньо до інтерфейсу, у якому вже працюють агенти, — без перемикання форматів, повторного введення даних і паралельних потоків, які доведеться звіряти згодом.',
        },
        {
          heading: 'Бронювання та післяпродажне обслуговування',
          description:
            'Агенти бронюють, виписують квитки та формують звітність в одній системі. DRCT централізує керування замовленнями NDC, тож зміни, скасування й повернення оформлюються в одному місці. Стандартні операції агенти виконують самостійно, а у складних випадках звертаються до підтримки.',
        },
      ],
    },
    products: {
      heading: 'Продукти для IATA-агентств',
      description:
        'DRCT пропонує інструменти для адаптації, збагачення й активації пропозицій авіакомпаній у NDC та інших каналах дистрибуції — для агентств, які працюють із GDS і прямими каналами.',
      items: [
        {
          tag: 'Повнофункціональний інтерфейс для бронювання',
          ctaLabel: 'Запланувати демо',
          description:
            'Окреме середовище для бронювання й обслуговування для IATA-агентів, які хочуть працювати поза GDS або паралельно з нею. Повний доступ до контенту з GDS, NDC та прямих каналів авіакомпаній в одному інтерфейсі.',
          previewLabel: 'Попередній перегляд робочого середовища',
        },
        {
          tag: 'NDC всередині GDS',
          ctaLabel: 'Докладніше',
          description:
            'Для агентів, які переважно працюють у GDS: Extension додає контент NDC, збагачені пропозиції та прямий інвентар авіакомпаній до інтерфейсу GDS — без нової системи, додаткового навчання чи зміни процесів.',
          previewLabel: 'Попередній перегляд Extension',
        },
      ],
    },
    whyContent: {
      heading: 'Чому IATA-агенти обирають DRCT',
      description:
        'Повний доступ до контенту, простіші операційні процеси та впровадження NDC без перебудови звичної роботи.',
      items: [
        {
          title: 'Повний контент авіакомпаній, а не лише GDS',
          description:
            'Тарифи NDC, прямі пропозиції та додаткові послуги відображаються поруч із результатами GDS — із повною вартістю кожної пропозиції.',
        },
        {
          title: 'Інтеграція NDC без перебудови процесів',
          description:
            'Ми додаємо NDC безпосередньо в GDS. Агенти самі обирають інструмент, а звичні процеси не потрібно будувати заново.',
        },
        {
          title: 'Одна система для всього циклу бронювання',
          description:
            'Пошук, бронювання, виписка, зміни, повернення та звітність — без перемикання між інструментами й дублювання даних.',
        },
        {
          title: 'Прозорий облік і розрахунки BSP',
          description:
            'Звітність і звірка NDC через BSP обробляються в тому самому шарі, що й операції GDS. Процес залишається послідовним, прозорим для аудиту та інтегрованим із вашим бек-офісом.',
        },
        {
          title: 'Обслуговування після бронювання в інтерфейсі агента',
          description:
            'DRCT поєднує самообслуговування з підтримкою: стандартні дії агенти виконують самостійно, а зі складними операціями швидко допомагає централізована команда підтримки — без звернень до авіакомпанії.',
        },
        {
          title: 'Операційна підтримка 24/7',
          description:
            'Операційні проблеми з NDC можуть виникнути будь-коли. Команда підтримки DRCT працює цілодобово й допомагає зі складними випадками бронювання та питаннями розрахунків NDC.',
        },
      ],
    },
    finalCtaContent: {
      title: 'Готові підключити весь контент авіакомпаній у своєму агентстві?',
      description: 'Одна платформа для GDS і NDC — без перебудови робочих процесів.',
    },
    faqContent: {
      heading: 'FAQ',
      description: 'Не знайшли відповіді? Зверніться до нашої служби підтримки.',
      items: [
        {
          question: 'Як IATA-агенти отримують доступ до NDC-контенту через DRCT?',
          answer:
            'Через DRCT Workspace або DRCT Extension — залежно від робочого процесу. DRCT Workspace — це повнофункціональний інтерфейс для бронювання з доступом до контенту GDS, NDC та прямих каналів авіакомпаній в одному місці. DRCT Extension додає NDC-контент до звичного інтерфейсу GDS — без переходу на нову систему. Обидва інструменти підключені до єдиного нормалізованого шару контенту, тому пропозиції залишаються узгодженими незалежно від того, який інструмент використовують агенти.',
        },
        {
          question: 'Що на практиці передбачає інтеграція NDC для агентств?',
          answer:
            'Інтеграція NDC через DRCT означає підключення до пропозицій авіакомпаній через сучасні API з доступом до ширшого контенту, додаткових послуг і пакетів, недоступних у традиційних GDS. DRCT бере на себе всю технічну складність: нормалізує дані, формує пропозиції та передає їх до інтерфейсу агента. Агенти бачать зрозумілі й зіставні результати. Вам не потрібно окремо інтегруватися з кожною авіакомпанією.',
        },
        {
          question: 'Як керувати змінами, скасуваннями та поверненнями в замовленнях NDC?',
          answer:
            'DRCT централізує керування замовленнями в одному інтерфейсі. Для бронювань NDC агенти можуть самостійно виконувати стандартні дії після бронювання — змінювати місця, виправляти імена та скасовувати бронювання — безпосередньо в інтерфейсі DRCT. У складних випадках, зокрема коли процедура залежить від конкретної авіакомпанії, операційна команда DRCT допомагає цілодобово.',
        },
        {
          question: 'Чому іноді не вдається створити бронювання NDC і як DRCT розв’язує цю проблему?',
          answer:
            'Збої можуть виникати через перевищення часу очікування в системах авіакомпаній, закінчення терміну дії пропозиції або розбіжності в ціні. DRCT відстежує процес бронювання в реальному часі й показує зрозумілі повідомлення про помилки, щоб агенти знали, що сталося і що робити далі. У критичних випадках команда підтримки DRCT може втрутитися безпосередньо: звернутися до авіакомпанії та розв’язати проблему без участі агента.',
        },
        {
          question: 'Чи охоплює DRCT весь процес обліку NDC?',
          answer:
            'Так. DRCT обробляє звітність NDC у BSP разом із транзакціями GDS в одній системі. Це забезпечує послідовну й прозору звірку всіх типів бронювань та спрощує аудит. DRCT також підтримує інтеграцію з бек-офісом для агентств, чиї облікові системи потребують структурованих даних про транзакції.',
        },
      ],
    },
  },
  pl: {
    metaTitle: 'Rozwiązania dla biur podróży IATA | Dostęp do treści lotniczych przez DRCT',
    metaDescription:
      'Uzyskaj dostęp do treści lotniczych NDC i GDS na jednej platformie. DRCT pomaga biurom podróży IATA uprościć rezerwacje, uniknąć przełączania między systemami oraz sprawnie zarządzać biletami i obsługą posprzedażową.',
    heroContent: {
      title: 'Dla IATA agencji',
      subtitle:
        'Bezpośredni dostęp do ofert linii lotniczych dla IATA agencji obsługujących klientów indywidualnych i korporacyjnych — z integracją NDC w dotychczasowych procesach, spójną obsługą i całodobowym wsparciem ekspertów.',
      description:
        'IATA agencje mierzą się ze złożonością, którą większość platform pomija: zobowiązaniami wobec GDS, raportowaniem BSP, niespójnościami NDC i uzgadnianiem danych z systemami back-office. DRCT obsługuje wszystko w jednym systemie, aby Twój zespół mógł skupić się na sprzedaży zamiast na ciągłym rozwiązywaniu problemów.',
      ctaLabel: 'Zapytaj o demo',
    },
    distributionContent: {
      heading: 'Jak DRCT rozwiązuje problemy w dystrybucji agencyjnej',
      description:
        'Luki w ofercie, utrudnienia w procesach i złożoność BSP — rozwiązane na jednej platformie.',
      tabOneLabel: 'Dystrybucja i rozwój',
      tabTwoLabel: 'Operacje i kontrola',
      tabOneCards: [
        {
          title: 'Bezpośredni dostęp do pełnej oferty linii lotniczych',
          description:
            'DRCT zapewnia bezpośredni dostęp do pełnej oferty linii lotniczych — w tym taryf NDC, pakietów i usług dodatkowych — w jednym spójnym widoku.',
        },
        {
          title: 'Kontrolowany rozwój NDC',
          description:
            'DRCT umożliwia kontrolowany rozwój NDC — z zachowaniem równowagi między kanałami dystrybucji i pełnego dostępu do ofert.',
        },
      ],
      tabTwoCards: [
        {
          title: 'Oferty linii lotniczych w Twoim procesie pracy',
          description:
            'DRCT integruje oferty linii lotniczych z Twoim procesem pracy: wyszukiwanie, rezerwacja i obsługa odbywają się w jednym miejscu, na podstawie spójnych danych.',
        },
        {
          title: 'Scentralizowane zarządzanie zamówieniami NDC',
          description:
            'DRCT centralizuje zarządzanie zamówieniami NDC w jednym interfejsie i zapewnia całodobowe wsparcie w złożonych przypadkach.',
        },
        {
          title: 'Spójne raportowanie i uzgadnianie rozliczeń',
          description:
            'DRCT zapewnia spójne raportowanie i jednolity proces księgowania NDC — od rezerwacji po uzgodnienie rozliczeń.',
        },
      ],
    },
    workflowContent: {
      heading: 'Jak to działa',
      description:
        'Od dostępu do oferty i rezerwacji po księgowanie i wsparcie posprzedażowe — każdy etap przebiega w jednej warstwie DRCT.',
      sourceEyebrow: 'Oferta',
      sourceHeading: 'Oferta linii lotniczych',
      sourceItems: ['NDC', 'Tanie linie', 'Czartery'],
      coreHeading: 'Wzbogacanie i dostarczanie',
      pipelineSteps: [
        { number: '01', text: 'Wzbogacanie — usługi dodatkowe, pakiety, ceny' },
        { number: '02', text: 'Dostarczanie — do interfejsu agenta' },
        { number: '03', text: 'Sprzedaż — rezerwacja, wystawienie biletu, raportowanie' },
      ],
      coreEyebrow: 'Jedna warstwa',
      coreNote: 'Obsługa posprzedażowa — zmiany, zwroty, obsługa rezerwacji',
      destEyebrow: 'Sprzedaż i obsługa posprzedażowa',
      destHeading: 'Interfejs agenta',
      destItems: ['Dostarczanie', 'Sprzedaż', 'Obsługa posprzedażowa'],
      steps: [
        {
          heading: 'Wzbogacanie ofert',
          description:
            'Oferty linii lotniczych z różnych źródeł są normalizowane i wzbogacane: usługi dodatkowe, wybór miejsc i dynamiczne pakiety są łączone w kompletne, porównywalne oferty.',
        },
        {
          heading: 'Dostarczanie do procesów pracy',
          description:
            'Wzbogacone oferty trafiają do interfejsu, z którego agenci już korzystają — bez zmiany formatów, ponownego wprowadzania danych ani równoległych strumieni, które trzeba później uzgadniać.',
        },
        {
          heading: 'Rezerwacja i obsługa posprzedażowa',
          description:
            'Agenci rezerwują, wystawiają bilety i raportują w jednym systemie. DRCT centralizuje zarządzanie zamówieniami NDC, dlatego zmiany, anulowania i zwroty są obsługiwane w jednym miejscu — z samoobsługą w przypadku standardowych czynności i wsparciem w złożonych sytuacjach.',
        },
      ],
    },
    products: {
      heading: 'Produkty dla IATA agencji',
      description:
        'DRCT — narzędzia do dostosowywania, wzbogacania i aktywowania ofert linii lotniczych w NDC oraz innych kanałach dystrybucji dla agencji pracujących z GDS i kanałami bezpośrednimi.',
      items: [
        {
          tag: 'Pełny interfejs rezerwacyjny',
          ctaLabel: 'Zapytaj o demo',
          description:
            'Dedykowane środowisko do rezerwacji i obsługi dla IATA agentów, którzy chcą pracować poza GDS lub równolegle z nim. Pełny dostęp do ofert z GDS, NDC i bezpośrednich kanałów linii lotniczych w jednym interfejsie.',
          previewLabel: 'Podgląd środowiska pracy',
        },
        {
          tag: 'NDC w GDS',
          ctaLabel: 'Dowiedz się więcej',
          description:
            'Dla agentów pracujących głównie w GDS: Extension udostępnia treści NDC, wzbogacone oferty i bezpośrednie zasoby linii lotniczych w interfejsie GDS — bez nauki nowego systemu i bez zmian w procesach.',
          previewLabel: 'Podgląd Extension',
        },
      ],
    },
    whyContent: {
      heading: 'Dlaczego IATA agenci wybierają DRCT',
      description:
        'Pełny dostęp do ofert, sprawniejsze operacje i wdrożenie NDC bez przebudowy dotychczasowych procesów.',
      items: [
        {
          title: 'Pełna oferta linii lotniczych, nie tylko GDS',
          description:
            'Taryfy NDC, oferty bezpośrednie i usługi dodatkowe są widoczne obok wyników GDS — zawsze z pełną ceną.',
        },
        {
          title: 'Integracja NDC bez przebudowy procesów',
          description:
            'Umieszczamy NDC bezpośrednio w GDS. Agenci wybierają narzędzie, a dotychczasowych procesów nie trzeba budować od nowa.',
        },
        {
          title: 'Jeden system do obsługi całego cyklu rezerwacji',
          description:
            'Wyszukiwanie, rezerwacja, wystawianie biletów, zmiany, zwroty i raportowanie — bez przełączania się między narzędziami i ponownego wprowadzania danych.',
        },
        {
          title: 'Przejrzyste księgowanie i rozliczenia BSP',
          description:
            'Raportowanie i uzgadnianie rozliczeń NDC w BSP odbywa się w tej samej warstwie co GDS — spójnie, z pełną ścieżką audytu i integracją z systemem back-office.',
        },
        {
          title: 'Obsługa po rezerwacji w interfejsie agenta',
          description:
            'DRCT łączy samoobsługę ze wsparciem: standardowe czynności agenci wykonują samodzielnie, a złożone operacje szybko rozwiązuje scentralizowany zespół wsparcia — bez kontaktowania się z linią lotniczą.',
        },
        {
          title: 'Wsparcie operacyjne 24/7',
          description:
            'Problemy operacyjne NDC nie ograniczają się do godzin pracy. Zespół wsparcia DRCT jest dostępny przez całą dobę w przypadku eskalacji dotyczących rezerwacji i rozliczeń NDC.',
        },
      ],
    },
    finalCtaContent: {
      title: 'Chcesz udostępnić pełną ofertę linii lotniczych w swojej agencji?',
      description: 'Jedna platforma dla GDS i NDC — bez przebudowy procesów pracy.',
    },
    faqContent: {
      heading: 'FAQ',
      description: 'Nie znalazłeś odpowiedzi? Skontaktuj się z naszym zespołem wsparcia.',
      items: [
        {
          question: 'Jak IATA agenci uzyskują dostęp do treści NDC przez DRCT?',
          answer:
            'Za pośrednictwem DRCT Workspace lub DRCT Extension — zależnie od procesu pracy. DRCT Workspace to pełny interfejs rezerwacyjny z bezpośrednim dostępem do GDS, NDC i ofert linii lotniczych w jednym miejscu. DRCT Extension udostępnia treści NDC na dotychczasowym ekranie GDS — bez konieczności korzystania z nowego systemu. Oba narzędzia są połączone z tą samą znormalizowaną warstwą treści, dlatego oferty pozostają spójne niezależnie od narzędzia używanego przez agentów.',
        },
        {
          question: 'Co w praktyce obejmuje integracja NDC dla agencji?',
          answer:
            'Integracja NDC przez DRCT oznacza połączenie z ofertami linii lotniczych przez nowoczesne API oraz dostęp do bogatszych treści, usług dodatkowych i pakietów niedostępnych w tradycyjnych GDS. DRCT przejmuje całą złożoność: normalizuje dane, tworzy oferty i dostarcza je do interfejsu. Agenci widzą przejrzyste, porównywalne wyniki. Nie musisz integrować się osobno z każdą linią lotniczą.',
        },
        {
          question: 'Jak zarządzać zamówieniami NDC — zmianami, anulowaniami i zwrotami?',
          answer:
            'DRCT centralizuje zarządzanie zamówieniami w jednym interfejsie. W przypadku rezerwacji NDC agenci mogą samodzielnie wykonywać standardowe czynności po rezerwacji — zmieniać miejsca, wprowadzać korekty nazwisk i anulować rezerwacje — bezpośrednio w interfejsie DRCT. W złożonych przypadkach, w tym przy procesach specyficznych dla danej linii lotniczej, całodobowe wsparcie zapewnia zespół operacyjny DRCT.',
        },
        {
          question:
            'Dlaczego rezerwacje NDC czasami kończą się niepowodzeniem i jak DRCT sobie z tym radzi?',
          answer:
            'Niepowodzenia mogą wynikać z przekroczenia limitu czasu w systemie linii lotniczej, wygaśnięcia oferty lub rozbieżności cenowych. DRCT monitoruje procesy rezerwacji w czasie rzeczywistym i wyświetla jasne komunikaty o błędach, dzięki czemu agenci wiedzą, co się wydarzyło i co zrobić dalej. W krytycznych sytuacjach zespół wsparcia DRCT może interweniować bezpośrednio — również u linii lotniczej — i rozwiązać problem bez udziału agenta.',
        },
        {
          question: 'Czy DRCT obsługuje cały proces księgowania NDC?',
          answer:
            'Tak. DRCT obsługuje raportowanie NDC w BSP razem z transakcjami GDS w jednym systemie. Dzięki temu uzgadnianie danych jest spójne i przejrzyste na potrzeby audytu dla wszystkich typów rezerwacji. DRCT wspiera także integrację z systemami back-office agencji, które potrzebują ustrukturyzowanych danych transakcyjnych.',
        },
      ],
    },
  },
};

export const mergeIataAgenciesContent = (base, translation) => {
  if (Array.isArray(base))
    return base.map((item, index) => mergeIataAgenciesContent(item, translation?.[index]));
  if (base && typeof base === 'object')
    return Object.fromEntries(
      Object.entries(base).map(([key, value]) => [
        key,
        mergeIataAgenciesContent(value, translation?.[key]),
      ])
    );
  return translation ?? base;
};
